import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Inspection } from "@/types/Inspection.type";
import { SizeChart } from "@/types/SizeChart";
import { LoadingStatus } from "@/enums/LoadingStatus.enum";


export interface InspectionsState  {
    inspections: Inspection[];
    sizeCharts: SizeChart[];
    dataFetchStatus: LoadingStatus;
    error: string | null;
}
const initialState: InspectionsState = {
    inspections: [],
    sizeCharts: [],
    dataFetchStatus: LoadingStatus.IDLE,
    error: null,
};


const inspectionsDataSlice = createSlice({
    name: "inspections",
    initialState,
    reducers: {
        setInspectionList: (state, action: PayloadAction<Array<Inspection>>) => {
            state.inspections = action.payload;
            state.dataFetchStatus = LoadingStatus.SUCCEEDED;
        },
        setSizeCharts: (
            state,
            action: PayloadAction<SizeChart[]>
        ) => {
            state.sizeCharts = action.payload;
            state.dataFetchStatus = LoadingStatus.SUCCEEDED;
        },
        upsertInspection: (state, action: PayloadAction<Inspection>) => {
            const index = state.inspections.findIndex(
                (inspection) => inspection.id === action.payload.id
            );
            if (index >= 0) {
                state.inspections[index] = action.payload;
            } else {
                state.inspections.push(action.payload);
            }
        },
        mergeSizeCharts: (state, action: PayloadAction<SizeChart[]>) => {
            const existingIds = new Set(state.sizeCharts.map((c) => c.id));
            for (const chart of action.payload) {
                if (!existingIds.has(chart.id)) {
                    state.sizeCharts.push(chart);
                    existingIds.add(chart.id);
                }
            }
        },
        // setPageStructure: (
        //     state,
        //     action: PayloadAction<any>
        // ) => {
        //     state.templates = action.payload
        //     state.dataFetchStatus = LoadingStatus.Succeeded;
        // },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(saveAppData.pending, (state) => {
    //             state.dataFetchStatus = "loading";
    //         })
    //         .addCase(saveAppData.fulfilled, (state) => {
    //             state.dataFetchStatus = "success";
    //         })
    //         .addCase(saveAppData.rejected, (state) => {
    //             state.dataFetchStatus = "error";
    //         })
    //         .addCase(loadAppData.fulfilled, (state, action) => {
    //             // if (action.payload) {
    //                 Object.assign(state, action.payload, { dataFetchStatus: "success" });
    //             // }
    //             // state.dataFetchStatus = "success";
    //         });
    // },
});

export const { setInspectionList, setSizeCharts, upsertInspection, mergeSizeCharts } = inspectionsDataSlice.actions;
export default inspectionsDataSlice.reducer;
